var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackComma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.712 19.504C18.892 19.504 17.384 18.906 16.188 17.71C15.044 16.514 14.472 14.798 14.472 12.562C14.472 10.17 15.148 7.804 16.5 5.464C17.904 3.124 19.854 1.304 22.35 0.00399494L24.144 2.734C21.44 4.606 19.828 6.972 19.308 9.832C19.776 9.624 20.322 9.52 20.946 9.52C22.402 9.52 23.598 9.988 24.534 10.924C25.47 11.86 25.938 13.056 25.938 14.512C25.938 15.968 25.444 17.164 24.456 18.1C23.468 19.036 22.22 19.504 20.712 19.504ZM6.36 19.504C4.54 19.504 3.032 18.906 1.836 17.71C0.692 16.514 0.12 14.798 0.12 12.562C0.12 10.17 0.796 7.804 2.148 5.464C3.552 3.124 5.502 1.304 7.998 0.00399494L9.792 2.734C7.088 4.606 5.476 6.972 4.956 9.832C5.424 9.624 5.97 9.52 6.594 9.52C8.05 9.52 9.246 9.988 10.182 10.924C11.118 11.86 11.586 13.056 11.586 14.512C11.586 15.968 11.092 17.164 10.104 18.1C9.116 19.036 7.868 19.504 6.36 19.504Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackComma);
export default __webpack_public_path__ + "static/media/black-comma.0114ff80b332d2e8e35f2e37ff33abd0.svg";
export { ForwardRef as ReactComponent };